var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3017 1.34627C25.3608 2.15833 25.563 3.67438 24.7536 4.73557L12.7432 20.4828C12.3197 21.0381 11.6779 21.3831 10.9822 21.4294C10.2866 21.4757 9.60485 21.2188 9.11188 20.7245L1.48887 13.0814C0.546131 12.1362 0.546131 10.6063 1.48887 9.66105C2.43513 8.7123 3.97196 8.7123 4.91822 9.66105L10.5789 15.3366L20.9037 1.79932C21.716 0.734309 23.2387 0.531282 24.3017 1.34627Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.38cbfbdcce685625bbc06f9dc1ffa107.svg";
export { ForwardRef as ReactComponent };